import React from 'react';
import styled from 'styled-components';

const RadioContainer = styled.div`
    align-items: center;
    margin: 10px 0;
`;

const RadioInput = styled.input`
    -webkit-appearance: none;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    outline: none;
    border: 2px solid grey;
    :before {
        content: '';
        display: block;
        width: 50%;
        height: 50%;
        margin: 28% auto;
        border-radius: 50%;
    }
    :checked:before {
        background: #121180;
    }
    :checked {
    border-color: #121180;
    }
`;

const Title = styled.p`
    margin: 0 10px 8px 0;
    font-weight: 600;
    color: #121180;
`;

const Label = styled.label`
    margin: 0 10px;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
`;

const OptionContainer = styled.div`
    display: flex;
    align-items: center;
    margin: 10px 0;
`;

const DynamicContent = styled.p`
    color: #121180;
    margin: 4px 0 0 0;
    font-size: 14px;
    white-space: nowrap;
`;

const Radio = ({ isArabic, label: name, arabiclabel, value: selectedValue, options, onChange, dynamic, required, disabled, error }) => (
    <RadioContainer>
        <Title id={name} className={isArabic ? 'arabic' : ''}>{isArabic ? arabiclabel : name} {required && <span style={{color: 'red', marginLeft: '2px'}}>*</span>}</Title>
        {dynamic ? <DynamicContent>Options will render dynamically</DynamicContent> : options && options.map(({value, label, arabicLabel: arabicOption}, index) => <OptionContainer key={index} className={isArabic ? 'arabic' : ''}>
            <RadioInput disabled={disabled} style={{cursor: disabled ? 'not-allowed' : 'pointer'}} type='radio' value={value} checked={selectedValue === value} id={value} name={name} onChange={onChange} />
            <Label htmlFor={value} disabled={disabled} className="mb-0">{isArabic ? arabicOption : label}</Label>
        </OptionContainer>)}
        {error && <p className="text-danger m-0">{error}</p>}
    </RadioContainer>
);

export default Radio;